import { NameDto } from 'api/Common/Types'

export interface TradingAccountClientDto {
  id: string
  userName: number
  name: string | null
  country: {
    id: string
    name: string
  }
  tickmillCompanyId: number
  introducingBrokerAssignedAt: string

  introducingBroker: NameDto | null
}

export enum TradingAccountClientDtoKey {
  id = 'id',
  userName = 'userName',
  name = 'name',
  countryId = 'country.name',
  tickmillCompanyId = 'tickmillCompanyId',
  introducingBrokerAssignedAt = 'introducingBrokerAssignedAt',
}
